const createShareableUrl = id =>
  window.location.href.includes(id)
    ? window.location.href
    : `${window.location.href}/${id}`

export default createShareableUrl
